class SupportTicketAttachmentDetailsMapper {
  static createModelFromResponse(response) {
    if (!response) {
      return undefined;
    }
    return {
      id: response.id,
      fileName: response.file_name,
      url: response.url
    };
  }
}

export { SupportTicketAttachmentDetailsMapper };
//# sourceMappingURL=SupportTicketAttachmentDetailsMapper.js.map
